import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui-kit/src/components/layouts/Footer/Footer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui-kit/src/components/layouts/Header/Header.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Page"] */ "/vercel/path0/packages/ui-kit/src/components/layouts/Page/Page.styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/packages/ui-kit/src/components/organisms/AlgoliaSearch/AlgoliaSearch.component.tsx");
